export class ImageTransformation {
	flipH = false;
	flipV = false;
	rotate = 0;

	addFlipH(flip?: boolean): void {
		if (flip === undefined || flip) {
			this.flipH = !this.flipH;
		}
	}

	addFlipV(flip?: boolean): void {
		if (flip === undefined || flip) {
			this.flipV = !this.flipV;
		}
	}

	addRotation(rotation: number = 1): void {
		this.rotate += rotation;
	}

	toCacheKey(): string {
		return `r${this.rotate}h${this.flipH}v${this.flipV}`;
	}
}
